import { Component, OnInit, Output, Input, EventEmitter, OnDestroy, ElementRef, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { Subject } from 'rxjs';
import { AddressSearchService, QuoteDataCaptureService } from 'src/app/shared';
import { ActivatedRoute } from '@angular/router';
import { debounceTime, map } from 'rxjs/operators';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-pension-provider-search',
    templateUrl: './pension-provider-search.component.html',
    styleUrls: ['./pension-provider-search.component.scss'],
    imports: [ReactiveFormsModule, NgClass]
})
export class PensionProviderSearchComponent implements OnInit, OnDestroy {

  public resultAddress: any[];
  public suggestiontext: any[];
  searchTerm$ = new Subject<string>();
  isListAddressEnabled = true;
  noRecordFound = true;
  private subscription;
  public contentData;
  @Input() parent: UntypedFormGroup;
  @Input() pageName;
  @Input() controlName;
  @Input() controllerData;
  @Input() introProvider;
  // tslint:disable-next-line: no-output-on-prefix
  @Output() addressChoosen: EventEmitter<any> = new EventEmitter<any>();
  // tslint:disable-next-line:no-output-on-prefix
  @Output() selectedProvider: EventEmitter<any> = new EventEmitter<any>();

  constructor(private quoteDatacaptureService: QuoteDataCaptureService,
    private eRef: ElementRef,
    private activatedRoute: ActivatedRoute, private addressSearchService: AddressSearchService
  ) {
    this.contentData = this.activatedRoute.snapshot.data.contentData.addressSearch;
  }

  ngOnInit() {
    this.subscription = this.searchTerm$.pipe(map(res => res), debounceTime(200)).subscribe(res => {
      this.validate();
      this.isListAddressEnabled = true;

      if (res.length >= 1) {
        const addresses = this.quoteDatacaptureService.searchPensionProvider(this.introProvider, res);
        this.resultAddress = addresses;

        if (this.resultAddress && this.resultAddress.length >= 1) {
          this.noRecordFound = false;
          this.suggestiontext = this.resultAddress.map(r => r.Name);
        } else {
          // Call async method (returns Observable)
          this.addressSearchService.searchDummyAddress()
            .subscribe(resdummy => {
              this.noRecordFound = true;
              this.suggestiontext = resdummy.map((r: { suggestion: any; }) => r.suggestion);
            });
        }
      } else {
        this.suggestiontext = null;
      }
    });
  }

  onSelectProvider(selectedAddress) {
    if (!this.noRecordFound) {
      this.parent.get([this.controlName]).setValue(selectedAddress);
      const result = this.resultAddress.find(a => a.Name === selectedAddress);
      this.selectedProvider.emit(result);
      setTimeout(() => {
        this.isListAddressEnabled = false;
      }, 100);
    }
  }

  gettingCedingProvider = (): string => {
    let cedignProvider = null;
    const provider = this.introProvider;
    switch (provider) {
      case 'I':
        cedignProvider = 'L&G';
        break;
      case 'H':
        cedignProvider = 'Aegon';
        break;
      case 'F':
        cedignProvider = 'Sun Life';
        break;
      case 'J':
        cedignProvider = 'Reassure';
        break;
      case 'O':
        cedignProvider = 'Phoenix';
        break;
      default:
        cedignProvider = null;
    }
    return cedignProvider;
  }

  @HostListener('document:click', ['$event'])
  public clickout(event) {
    if (this.eRef.nativeElement.contains(event.target)) {
      this.isListAddressEnabled = true;
    } else {
      this.isListAddressEnabled = false;
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  validate() {
    const nameValidation: RegExp = /^[a-zA-Z0-9@&<>,\/=\d]+(?: [a-zA-Z0-9@&<>,=\/\d]+)*$/g;
    const forbidden = nameValidation.test(this.parent.get(this.controlName).value);
    if (!forbidden  && this.parent.get(this.controlName).value) {
      this.parent.get(this.controlName).setErrors({ notValidPensionProvider: true });
    }
  }
}
